import { render } from "./Start.vue?vue&type=template&id=1537fde0"
const script = {}

import "./Start.vue?vue&type=style&index=0&id=1537fde0&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__